import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Task } from './task.model';

const axios = useAxios();

export interface TaskService {
  Fetch: () => Promise<AxiosResponse<Task[]>>;
}

const Fetch = (): Promise<AxiosResponse<Task[]>> => axios.Get<Task[]>('/api/tasks');

export default { Fetch } as TaskService;
